var word = {};
module["exports"] = word;
word.adjective = require("./adjective");
word.adverb = require("./adverb");
word.conjunction = require("./conjunction");
word.interjection = require("./interjection");
word.noun = require("./noun");
word.preposition = require("./preposition");
word.verb = require("./verb");
